import { createSelector } from 'reselect';
import { FORECAST_CATEGORY } from '../constants/DealGroupingType';
import { deriveNewYearAlertDismissedStorageValue, getGoalsBugAlertDismissedStorageValue } from '../utils/alertsUtils';
import { getCurrentMonth, getCurrentYear, INITIAL_MONTH } from '../utils/dateUtils';
import { getIsUngatedToGoalsBugAlert } from './authSelectors';
import { getAutomationFetchSucceeded, getIsProcessingDeals } from './automationSelectors';
import { getCurrentDate } from './dateSelectors';
import { getDealGroupingTypeFilter } from './filtersSelectors';
export const getShowProcessingAlert = createSelector([getDealGroupingTypeFilter, getAutomationFetchSucceeded, getIsProcessingDeals], (dealGroupingType, automationFetchSucceeded, isProcessingDeals) => {
  return dealGroupingType === FORECAST_CATEGORY && automationFetchSucceeded && isProcessingDeals;
});
const ENABLE_NEW_YEAR_ALERT = false;
export const getDismissedNewYearAlert = state => {
  return state.alerts.dismissedNewYearAlert;
};
export const deriveNewYearAlertState = createSelector([getDismissedNewYearAlert, getCurrentDate], (dismissedNewYearAlert, currentDate) => {
  const currentMonth = getCurrentMonth(currentDate);
  const currentYear = getCurrentYear(currentDate);
  return !dismissedNewYearAlert && !deriveNewYearAlertDismissedStorageValue(currentYear) && currentMonth === INITIAL_MONTH && ENABLE_NEW_YEAR_ALERT;
});
export const getDismissedExchangeRateAlert = state => {
  return state.alerts.dismissedExchangeRateAlert;
};
export const getDismissedAIForecastingV2Alert = state => {
  return state.alerts.dismissedAIForecastingV2Alert;
};
export const getDismissedGoalsBugAlert = state => {
  return state.alerts.dismissedGoalsBugAlert;
};
export const getShouldShowGoalsBugAlert = createSelector([getIsUngatedToGoalsBugAlert, getDismissedGoalsBugAlert], (isUngatedToGoalsBugAlert, dismissedGoalsBugAlert) => isUngatedToGoalsBugAlert && !dismissedGoalsBugAlert && !getGoalsBugAlertDismissedStorageValue());